import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DataTypeComponent } from '../../data-type-component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PromotionExcludeService } from './promotion-exclude.service';

@Component({
  selector: 'app-promotion-exclude',
  templateUrl: './promotion-exclude.component.html',
  styleUrls: ['./promotion-exclude.component.scss'],
  standalone: false,
})
export class PromotionExcludeComponent extends DataTypeComponent implements OnInit {
  fg: UntypedFormGroup;
  playerId: number;
  promoExclude: boolean;
  success: boolean = false;
  updatingInProgress: boolean = false;
  promoExcludeEditMode: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private service: PromotionExcludeService,
    private changesDetector: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {}

  override setRowData(entity: any) {
    this.promoExclude = entity?.promoExclude;
    this.playerId = entity.details?.playerId;
    this.initialize();
  }

  update() {
    this.updatingInProgress = true;
    const rawValue = this.fg.getRawValue();
    this.service
      .update(this.playerId, {
        promotionExclude: rawValue.promotionExclude,
      })
      .subscribe(
        () => {
          this.toggleEditMode();
          this.fg.disable();
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 2000);
          this.updatingInProgress = false;
        },
        () => {
          this.success = false;
          this.updatingInProgress = false;
        }
      );
  }

  toggleEditMode() {
    this.promoExcludeEditMode = !this.promoExcludeEditMode;
    if (this.promoExcludeEditMode) {
      this.fg.enable();
    } else {
      this.initialize();
    }
  }

  private initialize() {
    this.service.get(this.playerId).subscribe((d) => {
      this.fg = this.fb.group({
        promotionExclude: [d.promotionExclude, Validators.required],
      });
      this.changesDetector.detectChanges();
      this.fg.disable();
    });
  }
}
